const formatMiles = (value: number) =>
    new Intl.NumberFormat("en-GB", {
        style: "unit",
        unitDisplay: "long",
        unit: "mile",
    }).format(value);

export default formatMiles;
